export default __webpack_public_path__ + "static/media/sticker-oi.56dc1046.png";